import React, { useState } from "react";
import {  useNavigate } from 'react-router-dom';

const AddChariot = () => {
  const [view, setView] = useState("global_ethics"); // default view
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", view, formData);
    setFormData({});
  };

  return (
    <div className="p-6">
      {/* Button Toggle */}
      <div className="flex gap-4 mb-6">
        <button
          className={`p-2 border rounded ${
            view === "global_ethics" ? "bg-[#e64a32] text-white" : "bg-gray-200"
          }`}
          onClick={() => {
            setView("global_ethics");
            setFormData({});
          }}
        >
          Global Ethics
        </button>
        <button
          className={`p-2 border rounded ${
            view === "ai_career_chariot"
              ? "bg-[#e64a32] text-white"
              : "bg-gray-200"
          }`}
          onClick={() => {
            setView("ai_career_chariot");
            setFormData({});
          }}
        >
          AI Career Chariot
        </button>
      </div>

      {/* Global Ethics Form */}
      {view === "global_ethics" && (
        <form
          onSubmit={handleSubmit}
          className="border p-4 rounded shadow max-w-xl bg-white"
        >
          <h2 className="text-xl font-bold mb-4">Global Ethics Form</h2>
          <input
            type="text"
            name="chariotName"
            placeholder="Chariot Name"
            value={formData.chariotName || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="theme"
            placeholder="Theme"
            value={formData.theme || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="religion"
            placeholder="Religion"
            value={formData.religion || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="wheelNumber"
            placeholder="Wheel Number"
            value={formData.wheelNumber || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="wheelName"
            placeholder="Wheel Name"
            value={formData.wheelName || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="moralScienceQuestion"
            placeholder="Moral Science Question"
            value={formData.moralScienceQuestion || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="ageGroup"
            placeholder="Age Group"
            value={formData.ageGroup || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="standard"
            placeholder="Standard"
            value={formData.standard || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <textarea
            name="religiousQuote"
            placeholder="Religious Quote"
            value={formData.religiousQuote || ""}
            onChange={handleChange}
            className="block w-full mb-4 p-2 border rounded"
          />
          <button
            type="submit"
            className="bg-[#e64a32] text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Submit
          </button>
          <button
            onClick={() => navigate('/chariottable')}
            className="mt-4 px-4 py-2 bg-[#e64a32] text-white rounded flex gap-4  "
            >
            Go Back
            </button>
        </form>
      )}

      {/* AI Career Chariot Form */}
      {view === "ai_career_chariot" && (
        <form
          onSubmit={handleSubmit}
          className="border p-4 rounded shadow max-w-xl bg-white"
        >
          <h2 className="text-xl font-bold mb-4">AI Career Chariot Form</h2>
          <input
            type="text"
            name="chariotName"
            placeholder="Chariot Name"
            value={formData.chariotName || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="theme"
            placeholder="Theme"
            value={formData.theme || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="aiCareerRole"
            placeholder="AI Career Role"
            value={formData.aiCareerRole || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="wheelNumber"
            placeholder="Wheel Number"
            value={formData.wheelNumber || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="wheelName"
            placeholder="Wheel Name"
            value={formData.wheelName || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="moralScienceQuestion"
            placeholder="Moral Science Question"
            value={formData.moralScienceQuestion || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="ageGroup"
            placeholder="Age Group"
            value={formData.ageGroup || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <input
            type="text"
            name="standard"
            placeholder="Standard"
            value={formData.standard || ""}
            onChange={handleChange}
            className="block w-full mb-2 p-2 border rounded"
          />
          <textarea
            name="aiInsight"
            placeholder="AI Insight"
            value={formData.aiInsight || ""}
            onChange={handleChange}
            className="block w-full mb-4 p-2 border rounded"
          />
          <button
            type="submit"
            className="bg-[#e64a32] text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Submit
          </button>

          <button
            onClick={() => navigate('/chariottable')}
            className="mt-4 px-4 py-2 bg-[#e64a32] text-white rounded flex gap-4  "
            >
            Go Back
            </button>
        </form>
      )}
    </div>
  );
};

export default AddChariot;
